import { QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'react'
import { BrowserRouter, Navigate, Route } from 'react-router-dom'
import { RedirectIfAuthed, RequireAuth } from './auth/RequireAuth'
import { APP_ROUTES } from './constants/routes'
import { createAppQueryClient } from './helpers/query-client'
import { SentryRoutes } from './helpers/sentry-routes'
import { AuthProvider } from './hooks/useAuth'
import { VendorShell } from './layout/VendorShell'
import { InventoryPage } from './pages/InventoryPage'
import { LocationsPage } from './pages/LocationsPage'
import { LoginPage } from './pages/LoginPage'
import { OrdersPage } from './pages/OrdersPage'
import { OverviewPage } from './pages/OverviewPage'
import { PlaceholderPage } from './pages/PlaceholderPage'

export default function App() {
  const [queryClient] = useState(createAppQueryClient)

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <SentryRoutes>
            <Route
              path={APP_ROUTES.login}
              element={
                <RedirectIfAuthed>
                  <LoginPage />
                </RedirectIfAuthed>
              }
            />
            <Route
              element={
                <RequireAuth>
                  <VendorShell />
                </RequireAuth>
              }
            >
              <Route index element={<OverviewPage />} />
              <Route path="inventory" element={<InventoryPage />} />
              <Route path="locations" element={<LocationsPage />} />
              <Route path="orders" element={<OrdersPage />} />
              <Route path="settings" element={<PlaceholderPage title="Settings" />} />
              <Route path="*" element={<Navigate to={APP_ROUTES.home} replace />} />
            </Route>
          </SentryRoutes>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
